import { ga } from 'js/analytics/adapters'

export const trackLogin = ({ method: login_method }) => {
  ga.track('Log In', { 'Login Method': login_method })
}
